import { render, staticRenderFns } from "./GeneralInfomation.vue?vue&type=template&id=39775d2b&"
import script from "./GeneralInfomation.vue?vue&type=script&lang=js&"
export * from "./GeneralInfomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports